var moduleMap = {
	"./GoogleAutoSuggestAddress": () => {
		return __webpack_require__.e(/* __federation_expose_GoogleAutoSuggestAddress */ 58).then(() => (() => ((__webpack_require__(24656)))));
	},
	"./IrisPage": () => {
		return __webpack_require__.e(/* __federation_expose_IrisPage */ 244).then(() => (() => ((__webpack_require__(97245)))));
	},
	"./Loading": () => {
		return __webpack_require__.e(/* __federation_expose_Loading */ 204).then(() => (() => ((__webpack_require__(44361)))));
	},
	"./Header": () => {
		return __webpack_require__.e(/* __federation_expose_Header */ 327).then(() => (() => ((__webpack_require__(916)))));
	},
	"./HeaderV3": () => {
		return __webpack_require__.e(/* __federation_expose_HeaderV3 */ 434).then(() => (() => ((__webpack_require__(10250)))));
	},
	"./Footer": () => {
		return __webpack_require__.e(/* __federation_expose_Footer */ 913).then(() => (() => ((__webpack_require__(94211)))));
	},
	"./SignInSlider": () => {
		return __webpack_require__.e(/* __federation_expose_SignInSlider */ 381).then(() => (() => ((__webpack_require__(30210)))));
	},
	"./FindStoresSlider": () => {
		return __webpack_require__.e(/* __federation_expose_FindStoresSlider */ 348).then(() => (() => ((__webpack_require__(56420)))));
	},
	"./ShopDepartments": () => {
		return __webpack_require__.e(/* __federation_expose_ShopDepartments */ 521).then(() => (() => ((__webpack_require__(36678)))));
	},
	"./CommonExternal": () => {
		return __webpack_require__.e(/* __federation_expose_CommonExternal */ 634).then(() => (() => ((__webpack_require__(57681)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});